import React from 'react'
import { twMerge } from 'tailwind-merge'

export interface SidebarMenuButtonProps {
  label: string
  checked?: boolean
  onChange: () => void
  className?: string
  icon?: () => React.ReactNode
}

export const SidebarMenuButton: React.FC<SidebarMenuButtonProps> = ({
  label,
  checked = false,
  onChange,
  className = '',
  icon,
}) => {
  return (
    <label
      className={twMerge(
        'flex cursor-pointer items-center gap-2 rounded-md px-3 py-2 transition-all duration-150',
        'bg-bgPrimaryBase hover:bg-bgSecondary active:bg-bgSecondary',
        'hover:[&>span]:text-textSecondary active:[&>span]:text-textPrimary',
        '[&>svg]:h-5 [&>svg]:w-5',
        'hover:[&>svg]:fill-iconSecondary',
        checked &&
          'bg-bgSecondary [&>span]:text-textPrimary [&>svg]:fill-iconSecondary',
        className,
      )}
    >
      <input
        type="radio"
        className={'hidden'}
        checked={checked}
        onChange={() => onChange()}
      />
      {icon?.()}
      <span
        className={twMerge(
          'text-M text-textTertiary hover:text-textSecondary active:text-textPrimary',
          'select-none',
        )}
      >
        {label}
      </span>
    </label>
  )
}
